import { Bone, SHIMMER_STYLE } from "@ui/Molecules/Skeleton/Bone";

export function TopBarSkeleton() {
	return (
		<header className="sticky top-0 z-[900] hidden h-[72px] items-center gap-8 border-b border-[var(--border-default)] bg-[var(--surface-default)] px-10 md:flex">
			<style>{SHIMMER_STYLE}</style>
			<div className="flex items-center gap-2.5">
				<Bone width={32} height={32} radius="var(--radius-pill)" />
				<Bone width={150} height={18} />
			</div>
			<div className="flex gap-3">
				{[52, 48, 64, 44].map((w) => (
					<Bone key={w} width={w} height={14} />
				))}
			</div>
			<div className="flex flex-1 items-center justify-end gap-3.5">
				<Bone width={300} height={40} radius="var(--radius-sm)" />
				<Bone width={120} height={40} radius="var(--radius-sm)" />
			</div>
		</header>
	);
}
